export default __webpack_public_path__ + "static/media/illustration-features-tab-2.e933bd6d.svg";